import React from 'react';
import cn from 'classnames';
import styles from './Avatar.scss';

const Avatar = ({ className, image }) => {
  return (
    <div className={cn(styles.Avatar, className)}>
      {
        image ?
        <img
          className={styles.Image}
          src={`${image}`}
          alt="avatar"
        /> :
        <img src="https://app.nedvx.ru/static/media/icon-user.553f82d8.svg" alt=""/>
      }
    </div>
  );
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/common/Avatar/Avatar.js